<template>
  <div class="productDescription__seriesAndSku">
    <span v-if="getProductSeries" class="productDescription__seriesText">
      {{ getProductSeries }}
      <span class="productDescription__pipeChar"></span>
    </span>
    <span v-if="getProductSku" class="productDescription__skuText">{{
      getProductSku
    }}</span>
    <!-- sku region -->
    <span v-if="getPartnerReferenceSku">
      <span class="productDescription__pipeChar"></span
      ><span class="productDescription__partnerProductNumber">{{
        getPartnerReferenceSku
      }}</span>
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  computed: {
    ...mapGetters("product", ["getProduct"]),
    getPartnerReferenceSku() {
      const product = this.getProduct;
      if (
        product &&
        product.SelectedSku &&
        product.SelectedSku.PartnerReferenceSku
      ) {
        return `Partner Reference Sku: ${product.SelectedSku.PartnerReferenceSku}`;
      } else return null;
    },
    getProductSku() {
      const product = this.getProduct;
      if (product && product.SelectedSku)
        return `SKU: ${product.SelectedSku.SkuCode}`;
      else return "SKU: Select options for SKU";
    },
    getProductSeries() {
      const product = this.getProduct;
      if (product && product.Series) {
        const { SeriesCode } = product.Series;
        const seriesCodeMsg = `${SeriesCode} Series`;
        return SeriesCode ? seriesCodeMsg : "";
      } else return "";
    }
  }
};
</script>

<style lang="scss" scoped>
.productDescription {
  &__seriesAndSku {
    color: $darkgray;
    font-size: 16px;
    font-family: $body;
    letter-spacing: 0.2px;
    text-align: left;
    margin-top: 10px;

    @include media-breakpoint-up(lg) {
      margin-top: 8px;
    }
  }
  &__seriesText,
  &__skuText {
    display: block;
    line-height: 24px;
    @include media-breakpoint-up(sm) {
      display: inline;
    }
  }
  &__pipeChar {
    display: none;
    margin: 0 15px;
    @include media-breakpoint-up(sm) {
      display: inline-block;
    }
    &::after {
      content: "|";
    }
  }
  &__partnerProductNumber {
    display: block;
    margin-top: 10px;
  }
}
</style>
